import { initDropdowns } from './components/dropdowns.js';
import { initMobileMenu } from './components/mobileMenu.js';
import { initAlerts } from './components/alerts.js';
import { initBackLink } from './components/backLink.js';
import { initPills } from './components/pills.js';
import { initTabs } from './components/tabs.js';
import { initProgressBars } from './components/progressBars.js';
import { initBackToTop } from './components/backToTop.js';
import { initModal } from './components/modal.js';

if (typeof window !== 'undefined') {
  initDropdowns();
  initMobileMenu();
  initAlerts();
  initBackLink();
  initPills();
  initTabs();
  initProgressBars();
  initBackToTop();
  initModal();
}
